
export const fontOptions =
	[
		'Roboto',
		'Dosis',
		'Open Sans',
		'Lobster',
		'Noto Serif',
		'Dancing Script'
	]

export default fontOptions;